const DEFAULT_DELAY = 500;

export function asyncDelay(start, delay = DEFAULT_DELAY) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, Math.min(delay - (new Date().getTime() - start), delay));
  });
}

export async function asyncTimeout(timeout) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, timeout);
  });
}

export function decimalToDollars(str) {
  if (!str) {
    return 0;
  }

  return Math.round(100 * parseFloat(str.replace(/[$,]/g, "")));
}

function addCommas(dollar) {
  return dollar.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function toDollars(cents, includeSign = false) {
  let str = "" + Math.ceil(Math.abs(cents));

  let prefix = includeSign ? "$" : "";
  if (cents < 0) {
    prefix = prefix + "-";
  }

  switch (str.length) {
    default:
      return (
        prefix +
        addCommas(str.substring(0, str.length - 2)) +
        "." +
        str.substring(str.length - 2, str.length)
      );
    case 0:
      return prefix + "0.00";
    case 1:
      return prefix + "0.0" + str;
    case 2:
      return prefix + "0." + str;
  }
}

export function parseIdDict(arr, key = "ID") {
  return arr.reduce((dict, item) => {
    dict[item[key]] = item;
    return dict;
  }, {});
}

export function randomString(howMany, chars) {
  chars =
    chars || "abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUWXYZ0123456789";

  var result = "";
  for (let i = 0; i < howMany; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}

export function numberToBoolean(number) {
  return number === 1 || number === "1";
}

export function minutesToHours(minutes) {
  if (!minutes) {
    return 0;
  }

  return (minutes / 60).toFixed(2);
}

export function toWeekday(num) {
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return days[num];
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function fetchValidatedPhone(phone) {
  return "1" + phone.replaceAll(" ", "");
}

export function fetchValidatedToken(token) {
  return token.replaceAll(" ", "");
}
